import * as angular from "angular";

export class SelectObjectTypeController {
    static $inject = ['$uibModalInstance', 'fileRestService'];
    code: string = '';

    constructor(private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance) {
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    };

    select() {
        this.$uibModalInstance.close(this.code);
    }
}



// WEBPACK FOOTER //
// ./src/components/files/folder-tree/selectObjectType.ts